// extracted by mini-css-extract-plugin
export default {"mw914":"MyAds-module--mw914--h6V0n","customPaddingTop":"MyAds-module--customPaddingTop--DPCaT","asideBoxShadow":"MyAds-module--asideBoxShadow--rSN8W"};